import { Injectable } from '@angular/core';
import { MediaCapture, MediaFile, CaptureVideoOptions } from '@awesome-cordova-plugins/media-capture/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { AppPlatformService } from '../platform/app-platform.service';
// declare const window: any;
@Injectable({
  providedIn: 'root'
})
export class VideoUploadService {

  constructor(
    private mediaCapture: MediaCapture,
    private file: File,
    private appPlatformService:AppPlatformService,
  ) { }

  captureVideo(): Promise<any[]> {
    console.log("captureVideo!!")
    return new Promise((resolve, reject) => {
      if (!this.appPlatformService.isAppPlatform()) {
        reject('Plugin no disponible en esta plataforma');
        return;
      }

      const options: CaptureVideoOptions = {
        limit: 1,
        duration: 20,
        quality: 0.8 // Calidad alta (0 = baja, 1 = alta)
      };

      this.mediaCapture.captureVideo(options)
        .then((data: MediaFile[]) => {
          console.log('Video capturado exitosamente:', data);
          resolve(data);
        })
        .catch((error: any) => {
          console.error('Error capturando video:', error);
          reject(error);
        });
    });
  }

  async copyFileToSafeDirectory(localURL, fileName, isOffline) {
    let dir = localURL.split("/");
    dir.pop();
    let fromDir = dir.join("/");

    let toDir;
    if(isOffline) {
      toDir = this.file.dataDirectory;
    } else {
      toDir = this.file.dataDirectory  + 'ch-online-video-audit';
      await this.file.createDir(this.file.dataDirectory, 'ch-online-video-audit', false).catch(() => {});
    };

    const copiedFile = await this.file.copyFile(fromDir, fileName, toDir, fileName);
    console.log("response copyFileToSafeDirectory: ",copiedFile)
    return copiedFile.nativeURL;
 }

  async prepareBlobFile(localURL, fileName) {
    return new Promise(async (resolve, reject) => {
        let dir = localURL.split("/");
        dir.pop();
        let fromDir = dir.join("/");
        let toDir = this.file.dataDirectory  + 'ch-online-video-audit';
        console.log("toDir::",toDir)
        await this.file.createDir(this.file.dataDirectory, 'ch-online-video-audit', false).catch(() => {});
        let copiedFile;
        try {
          copiedFile = await this.file.copyFile(fromDir, fileName, toDir, fileName);
          console.log("response copyFile: ",copiedFile)
        } catch (error) {
          console.log("error prepareBlobFile:",error)
          reject(error);
          return;
        }
        this.file.resolveLocalFilesystemUrl(copiedFile.nativeURL)
        .then(entry => {
          (entry as any).file(file => {
            const reader = this.getFileReader();

            reader.onloadend = () => {
              const blob = new Blob([reader.result], { type: file.type });
              resolve({blob, nativeURL: copiedFile.nativeURL });
            };
            reader.onerror = (e) => reject(e);
            reader.readAsArrayBuffer(file);
          });
        })
        .catch(error => reject(error));
    });
  }

  getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
    return zoneOriginalInstance || fileReader;
  }

   // convertFileToBase64(file): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     const reader = this.getFileReader();
  //     reader.onload = () => {
  //       const base64String = reader.result as string;
  //       // Remover el prefijo "data:video/mp4;base64," para guardar solo el base64
  //       const base64Data = base64String.split(',')[1];
  //       resolve(base64Data);
  //     };
  //     reader.onerror = reject;
  //     reader.readAsDataURL(file);
  //   });
  // }

  //*  checklist - offline videos
  async copyFileToAppDirectory(file, fileName: string, isOffline): Promise<string> {
    try {
      // Crear un blob del archivo seleccionado
      // const arrayBuffer = await file.arrayBuffer();
      const arrayBuffer = await this.fileToArrayBuffer(file);
      const blob = new Blob([arrayBuffer], { type: file.type });

      // Generar nombre único para evitar conflictos
      const uniqueFileName = fileName;

      // Directorio donde guardar (persistente)
      let targetPath;
      if(isOffline) {
        targetPath = this.file.dataDirectory;
      } else {
        targetPath = this.file.dataDirectory  + 'ch-online-video-audit';
        await this.file.createDir(this.file.dataDirectory, 'ch-online-video-audit', false).catch(() => {});
      };


      // Escribir el archivo
      const writeRes = await this.file.writeFile(targetPath, uniqueFileName, blob, { replace: true });
      // console.log("writeRes::",writeRes)
      // Retornar la ruta completa
      return writeRes.nativeURL;
      // return `${targetPath}${uniqueFileName}`;

    } catch (error) {
      console.error('Error copiando archivo de galeria:', error);
      throw error;
    }
  }

  fileToArrayBuffer(file): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = this.getFileReader();
      reader.onload = () => resolve(reader.result as ArrayBuffer);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  }



  createBlobFromPath(nativeURL) {
    return new Promise(async (resolve, reject) => {
        this.file.resolveLocalFilesystemUrl(nativeURL)
        .then(entry => {
          (entry as any).file(file => {
            const reader = this.getFileReader();

            reader.onloadend = () => {
              const blob = new Blob([reader.result], { type: file.type });
              resolve(blob);
            };
            reader.onerror = (e) => reject(e);
            reader.readAsArrayBuffer(file);
          });
        })
        .catch(error => reject(error));
    });
  }

  getDirectoryFromPath(fullPath: string): string {
    return fullPath.substring(0, fullPath.lastIndexOf('/') + 1);
  }

  getFileNameFromPath(fullPath: string): string {
    return fullPath.substring(fullPath.lastIndexOf('/') + 1);
  }

  validateVideoType(fileType): boolean {
    const acceptedVideoTypes = [
      'video/mp4',
      'video/webm',
      'video/mov',
      'video/quicktime'
    ];
    return acceptedVideoTypes.includes(fileType);
  };


}
